import { Component,ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { ModalController } from "@ionic/angular";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
@Component({
  selector: 'app-customer-site-reports-page',
  templateUrl: 'customer-site-reports.page.html',
  styleUrls: [
    './customer-site-reports.page.scss',
  ]
})
export class CustomerSiteReportPage {
  settingsFields:any[];
  systemSetting:any[];
   constructor(
        private systemSettingService: SystemSettingService,
        private toasterService: ToasterService,
        private router: Router,
        public authService: GtrakAuthService,
      ) { 
  
    }
  loading:boolean=true ;
  customerSiteReports:any;
  groupedReports:any;


  ngOnInit() {
    this.loadData(); 
  }

async loadData() {
    this.loading=false;
    await this.systemSettingService.getCustomerSiteReports(this.authService.user.role).then((response) => {
        this.customerSiteReports = response;

      });
      
        this.loading=true;
  this.groupReportsByCategory();
 }
  async viewCustomerReports(report) {
    this.loading=false;
    if (!report.apP_TARGET) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please add link or query in web_reports table."
      );
      this.loading=true;
      return false;
    }

    const target = report.apP_TARGET.toLowerCase();

    if (report.reportType === 'link' && target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a link, but found a query."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'query'  && !target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a query, but not found."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'link') {
      if(report.apP_TARGET!=null){
      this.router.navigate([`admin-page/customer-site-reports/${report.apP_TARGET}`]);
      }
      else{
         this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
      }
    } 
    else if (report.reportType === 'query') {
      this.router.navigate([`admin-page/customer-site-reports/query-view/${report.id}`]);
    } 
    else {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
    }
        this.loading=true;
  }

  groupReportsByCategory() {
    this.groupedReports = this.customerSiteReports.reduce((acc, report) => {
      const category = report.category || 'Uncategorized';
      if (!acc[category]) acc[category] = [];
      acc[category].push(report);
      return acc;
    }, {});
  }
}